import React, { useEffect, useState } from 'react'
import classes from "./MatchDetails.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Container from '../component/Container';
import { FaArrowLeft, FaCircle, FaMinus } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import { matchDetailsApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import Lineups from '../component/Lineups';
import MatchStats from '../component/MatchStats';
import { teamStatsCalculator } from '../utils/helper';
import MatchEvents from '../component/MatchEvents';
import moment from 'moment-timezone';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const MatchDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [matchDetails, setMatchDetails] = useState(null);
    const [matchDetails2, setMatchDetails2] = useState(null);
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const [tab, setTab] = useState("lineups");
    const [teamStatistics, setTeamStatistics] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(false);
    const dispatch=useDispatch();

    const {t}=useTranslation();

    const fetchMatchDetails = async (match_fixture_id, load) => {
        try {
            if (load) {
                setLoading(true);
            }
            setLoader(true);
            const response = await matchDetailsApi(match_fixture_id, userDetails?.token);
            setMatchDetails(response?.data);
            setMatchDetails2(JSON.parse(response?.data?.match_details));

            setTeamStatistics(teamStatsCalculator(JSON.parse(response?.data?.match_details), response?.data?.home_team_id, response?.data?.away_team_id));
            setLoading(false);
            setLoader(false);


        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("129"));
                navigate('/');
            }
            else {
                setLoading(false);
                setLoader(false);
                // toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
                console.log(error, 'error---');
            }
        }
    }

    console.log(matchDetails2, 'md');

    console.log(teamStatistics, 'ts...')

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchMatchDetails(location?.state?.match_fixture_id, true);
        }
        else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchMatchDetails(location?.state?.match_fixture_id, false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader]);

    console.log(teamStatistics, 'teamStatistics...');
    return (
        <Layout>
            <SubLayout>
                <div className={classes.header}>
                    <div className={classes.header_nav}>
                        <div className={classes.header_nav_container}>
                            <button type='button' className={classes.back_button}>
                                <FaArrowLeft className={classes.back_icon} onClick={() => navigate("/home")} />
                            </button>
                        </div>
                    </div>

                    {loading ? <SmallLoader /> : (
                        <div className={classes.match_details_container}>

                            {
                                // matchDetails?.match_status == "NS" ? (
                                //     <div className={classes.match_status}>
                                //         <p className={classes.status_text}>Not Started Yet</p>
                                //     </div>
                                // ) :
                                matchDetails?.match_status == "FT" ? (
                                    <div className={classes.match_status}>
                                        <p className={classes.status_text}>{t("92")}</p>
                                    </div>
                                ) :
                                    matchDetails?.match_status == "AET" ? (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>{t("92")}</p>
                                        </div>
                                    ) : matchDetails?.match_status == "PEN" ? (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>{t("92")}</p>
                                        </div>
                                    ) : matchDetails?.match_status == "SUSP" ? (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>{t("93")}</p>
                                        </div>
                                    ) :
                                        matchDetails?.match_status == "PST" ? (
                                            <div className={classes.match_status}>
                                                <p className={classes.status_text}>{t("94")}</p>
                                            </div>
                                        ) :
                                            matchDetails?.match_status == "CANC" ? (
                                                <div className={classes.match_status}>
                                                    <p className={classes.status_text}>{t("95")}</p>
                                                </div>
                                            ) :
                                                matchDetails?.match_status == "ABD" ? (
                                                    <div className={classes.match_status}>
                                                        <p className={classes.status_text}>{t("96")}</p>
                                                    </div>
                                                ) :
                                                    (matchDetails?.match_status == "AWD" || matchDetails?.match_status == "WO") ? (
                                                        <div className={classes.match_status}>
                                                            <p className={classes.status_text}>{t("96")}</p>
                                                        </div>
                                                    ) :
                                                        (matchDetails?.match_status == "1H" || matchDetails?.status == "LIVE") ?
                                                            (
                                                                <div className={classes.match_status}>
                                                                    <p className={classes.status_text}>
                                                                        <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                            style={{ fontSize: "8px" }}
                                                                        />
                                                                        <span style={{ marginLeft: "6px" }}>
                                                                            <>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            ) :
                                                            matchDetails?.match_status == "HT" ?
                                                                (
                                                                    <div className={classes.match_status}>
                                                                        <p className={classes.status_text}>
                                                                            <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                style={{ fontSize: "8px" }}
                                                                            />
                                                                            <span style={{ marginLeft: "6px" }}>
                                                                                {t("97")}{" "}<>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                ) : matchDetails?.match_status == "2H" ?
                                                                    (
                                                                        <div className={classes.match_status}>
                                                                            <p className={classes.status_text}>
                                                                                <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                    style={{ fontSize: "8px" }}
                                                                                />
                                                                                <span style={{ marginLeft: "6px" }}>
                                                                                    <>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    ) : matchDetails?.match_status == "ET" ?
                                                                        (
                                                                            <div className={classes.match_status}>
                                                                                <p className={classes.status_text}>
                                                                                    <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                        style={{ fontSize: "8px" }}
                                                                                    />
                                                                                    <span style={{ marginLeft: "6px" }}>
                                                                                        <>{matchDetails2?.fixture?.status?.elapsed}`</>{" "} {t("98")} {matchDetails2?.fixture?.status?.extra}`
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        ) : matchDetails?.match_status == "P" ?
                                                                            (
                                                                                <div className={classes.match_status}>
                                                                                    <p className={classes.status_text}>
                                                                                        <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                            style={{ fontSize: "8px" }}
                                                                                        />
                                                                                        <span style={{ marginLeft: "6px" }}>
                                                                                            {t("99")}{" "}<>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                        </span>
                                                                                    </p>
                                                                                </div>
                                                                            ) : null}

                            <div className={classes.match_details}>
                                <div className={classes.team}>
                                    <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.team_logo} />
                                    <p className={classes.team_name}>{matchDetails?.home_team_name}</p>
                                </div>
                                <div className={classes.score_container}>
                                    <p className={classes.score}>
                                        {matchDetails2?.goals?.home}
                                    </p>
                                    <div className={classes.separator}>
                                        <FaMinus className={classes.separator_icon} />
                                    </div>
                                    <p className={classes.score}>
                                        {matchDetails2?.goals?.away}
                                    </p>
                                </div>
                                <div className={classes.team}>
                                    <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.team_logo} />
                                    <p className={classes.team_name}>{matchDetails?.away_team_name}</p>
                                </div>
                            </div>

                            {/* {matchDetails?.match_status == "NS" &&
                            <div className={classes.match_timer_container}>
                                <p className={classes.match_timer}>
                                    {time}
                                </p>
                            </div>
                        } */}

                            <p className={classes.match_time} style={{ paddingTop: "10px" }}>
                                {moment.utc(matchDetails?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
                            </p>
                        </div>
                    )}

                    <div className={classes.tabs_container}>
                        <button type='button' className={`${classes.tab_option} ${tab === "lineups" && classes.active}`}
                            onClick={() => setTab("lineups")}
                        >
                            {t("101")}
                        </button>
                        <button type="button" className={`${classes.tab_option} ${tab === "stats" && classes.active}`}
                            onClick={() => setTab("stats")}

                        >
                            {t("102")}
                        </button>
                        <button type="button" className={`${classes.tab_option} ${tab === "events" && classes.active}`}
                            onClick={() => setTab("events")}

                        >
                            {t("103")}
                        </button>
                    </div>
                </div>

                {loading ? <SmallLoader /> : (
                    <>
                        <Container style={{ padding: "10px 10px" }}>
                            {matchDetails2 &&
                                tab === "lineups" ? (
                                <Lineups homeTeam={matchDetails2?.lineups?.[0]} awayTeam={matchDetails2?.lineups?.[1]} />
                            ) : tab === "stats" ? (
                                <MatchStats teamStatistics={teamStatistics} />
                            ) : tab === "events" ? (
                                <>
                                    <div className={classes.grid_col_2}>
                                        <MatchEvents
                                            team_name={matchDetails?.home_team_name}
                                            data={matchDetails2?.events?.filter((data) => {
                                                return (
                                                    data?.team?.name == matchDetails?.home_team_name &&
                                                    data?.type == "Goal" &&
                                                    data?.detail != "Missed Penalty"
                                                );
                                            })}
                                        />
                                        <MatchEvents
                                            team_name={matchDetails?.away_team_name}
                                            data={matchDetails2?.events?.filter((data) => {
                                                return (
                                                    data?.team?.name == matchDetails?.away_team_name &&
                                                    data?.type == "Goal" &&
                                                    data?.detail != "Missed Penalty"
                                                );
                                            })}
                                        />
                                    </div>
                                </>
                            ) : null
                            }

                        </Container>
                    </>
                )}


            </SubLayout>
        </Layout>
    )
}

export default MatchDetails

//  const homeTeamEvents = res?.data?.message[0]?.events?.filter((data) => {
//         return (
//           data?.team?.name == homeTeam &&
//           data?.type == "Goal" &&
//           data?.detail != "Missed Penalty"
//         );
//       });

//    const awayTeamEvents = res?.data?.message[0]?.events?.filter((data) => {
//         return (
//           data?.team?.name == awayTeam &&
//           data?.type == "Goal" &&
//           data?.detail != "Missed Penalty"
//         );
//       });